import { resolveComponent, createBlock, createCommentVNode, openBlock, withCtx, createElementVNode, toDisplayString, createVNode, withModifiers } from "vue";
/* empty css                */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
import { VChip } from "vuetify/components/VChip";
const _sfc_main = {
  name: "FilterChip",
  props: {
    filters: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: null
    },
    separator: {
      type: String,
      default: ", "
    },
    stringFilters: {
      type: String,
      default: null
    }
  },
  emits: ["clear"]
};
const _hoisted_1 = {
  class: "chip-title",
  style: { "white-space": "pre" }
};
const _hoisted_2 = { class: "chip-content" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = resolveComponent("b-icon");
  return $props.filters.length > 0 || $props.stringFilters ? (openBlock(), createBlock(VChip, {
    key: 0,
    class: "sr-module--tag-chip",
    label: "",
    variant: "outlined",
    size: "small"
  }, {
    append: withCtx(() => [
      createVNode(_component_b_icon, {
        icon: "maki:cross",
        size: "10",
        color: "#7E7E8B",
        class: "ml-2 mr-n1 c-pointer",
        onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("clear"), ["stop"]))
      })
    ]),
    default: withCtx(() => [
      createElementVNode("span", _hoisted_1, toDisplayString($props.label + ": "), 1),
      createElementVNode("span", _hoisted_2, toDisplayString($props.stringFilters || $props.filters.join($props.separator)), 1)
    ]),
    _: 1
  })) : createCommentVNode("", true);
}
const FilterChip = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  FilterChip as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
